import { render, staticRenderFns } from "./CadasDados.vue?vue&type=template&id=04c4edb1"
import script from "./CadasDados.vue?vue&type=script&lang=js"
export * from "./CadasDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports